/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface IdentityResponse
 */
export interface IdentityResponse {
  /**
   *
   * @type {string}
   * @memberof IdentityResponse
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof IdentityResponse
   */
  carrierName: string;
  /**
   *
   * @type {string}
   * @memberof IdentityResponse
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof IdentityResponse
   */
  userEmail: string;
}

/**
 * Check if a given object implements the IdentityResponse interface.
 */
export function instanceOfIdentityResponse(
  value: object,
): value is IdentityResponse {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("carrierName" in value) || value["carrierName"] === undefined)
    return false;
  if (!("userName" in value) || value["userName"] === undefined) return false;
  if (!("userEmail" in value) || value["userEmail"] === undefined) return false;
  return true;
}

export function IdentityResponseFromJSON(json: any): IdentityResponse {
  return IdentityResponseFromJSONTyped(json, false);
}

export function IdentityResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IdentityResponse {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    carrierName: json["carrierName"],
    userName: json["userName"],
    userEmail: json["userEmail"],
  };
}

export function IdentityResponseToJSON(json: any): IdentityResponse {
  return IdentityResponseToJSONTyped(json, false);
}

export function IdentityResponseToJSONTyped(
  value?: IdentityResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    carrierName: value["carrierName"],
    userName: value["userName"],
    userEmail: value["userEmail"],
  };
}
